/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_5Inputs */

const en_bot_never_5 = /** @type {(inputs: Bot_Never_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change its User-Agent or IP address to get around a site's rules.`)
};

const id_bot_never_5 = /** @type {(inputs: Bot_Never_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengganti User-Agent atau alamat IP untuk menghindari aturan situs.`)
};

/**
* | output |
* | --- |
* | "Change its User-Agent or IP address to get around a site's rules." |
*
* @param {Bot_Never_5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_5 = /** @type {((inputs?: Bot_Never_5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_5(inputs)
	return en_bot_never_5(inputs)
});